const borderRadius = {
  name: "border-radius",
  path: "/border-radius",
  title: "border-radius",
  description: "Utilities for controlling the border radius of an element.",
  value: {
    'border-radius': {
      'rounded': '4px',
      'rounded-none': '0px',
      "rounded-xs":"var(--radius-xs)",
      "rounded-sm":"var(--radius-sm)",
      "rounded-md":"var(--radius-md)",
      "rounded-lg":"var(--radius-lg)",
      "rounded-xl":"var(--radius-xl)",
      "rounded-2xl":"var(--radius-2xl)",
      "rounded-3xl":"var(--radius-3xl)",
      "rounded-4xl": 'var(--radius-4xl)',
      "rounded-full": 'calc(infinity * 1px)',
      "rounded-[<value>]":"<value>",
    },
    '':{
            "rounded-t-xs" :
`border-top-left-radius: var(--radius-xs);
border-top-right-radius: var(--radius-xs)`,
"rounded-t-sm" :
`border-top-left-radius: var(--radius-sm);
border-top-right-radius: var(--radius-sm)`,
"rounded-t-md" :
`border-top-left-radius: var(--radius-md);
border-top-right-radius: var(--radius-md)`,
"rounded-t-lg" :
`border-top-left-radius: var(--radius-lg);
border-top-right-radius: var(--radius-lg)`,
"rounded-t-xl" :
`border-top-left-radius: var(--radius-xl);  
border-top-right-radius: var(--radius-xl)`, 
"rounded-t-2xl" :
`border-top-left-radius: var(--radius-2xl);
border-top-right-radius: var(--radius-2xl)`,
"rounded-t-3xl" :
`border-top-left-radius: var(--radius-3xl);
border-top-right-radius: var(--radius-3xl)`,
"rounded-t-4xl" :
`border-top-left-radius: var(--radius-4xl); 
border-top-right-radius: var(--radius-4xl)`,
"rounded-t-full" :
`border-top-left-radius: calc(infinity * 1px); 
border-top-right-radius: calc(infinity * 1px)`,

"rounded-r-xs" :
`border-top-right-radius: var(--radius-xs);
border-bottom-right-radius: var(--radius-xs)`,
"rounded-r-sm" :
`border-top-right-radius: var(--radius-sm);
border-bottom-right-radius: var(--radius-sm)`,
"rounded-r-md" :
`border-top-right-radius: var(--radius-md);
border-bottom-right-radius: var(--radius-md)`,
"rounded-r-lg" :
`border-top-right-radius: var(--radius-lg);
border-bottom-right-radius: var(--radius-lg)`,
"rounded-r-xl" :
`border-top-right-radius: var(--radius-xl);  
border-bottom-right-radius: var(--radius-xl)`, 
"rounded-r-2xl" :
`border-top-right-radius: var(--radius-2xl);
border-bottom-right-radius: var(--radius-2xl)`,
"rounded-r-3xl" :
`border-top-right-radius: var(--radius-3xl);
border-bottom-right-radius: var(--radius-3xl)`,
"rounded-r-4xl" :
`border-top-right-radius: var(--radius-4xl); 
border-bottom-right-radius: var(--radius-4xl)`,
"rounded-r-full" :
`border-bottom-right-radius: calc(infinity * 1px); 
border-top-right-radius: calc(infinity * 1px)`,

"rounded-b-xs" :
`border-bottom-left-radius: var(--radius-xs);
border-bottom-right-radius: var(--radius-xs)`,
"rounded-b-sm" :
`border-bottom-left-radius: var(--radius-sm);
border-bottom-right-radius: var(--radius-sm)`,
"rounded-b-md" :
`border-bottom-left-radius: var(--radius-md);
border-bottom-right-radius: var(--radius-md)`,
"rounded-b-lg" :
`border-bottom-left-radius: var(--radius-lg);
border-bottom-right-radius: var(--radius-lg)`,
"rounded-b-xl" :
`border-bottom-left-radius: var(--radius-xl);  
border-bottom-right-radius: var(--radius-xl)`, 
"rounded-b-2xl" :
`border-bottom-left-radius: var(--radius-2xl);
border-bottom-right-radius: var(--radius-2xl)`,
"rounded-b-3xl" :
`border-bottom-left-radius: var(--radius-3xl);
border-bottom-right-radius: var(--radius-3xl)`,
"rounded-b-4xl" :
`border-bottom-left-radius: var(--radius-4xl); 
border-bottom-right-radius: var(--radius-4xl)`,
"rounded-b-full" :
`border-bottom-right-radius: calc(infinity * 1px); 
border-bottom-left-radius: calc(infinity * 1px)`,

"rounded-l-xs" :
`border-bottom-left-radius: var(--radius-xs);
border-top-left-radius: var(--radius-xs)`,
"rounded-l-sm" :
`border-bottom-left-radius: var(--radius-sm);
border-top-left-radius: var(--radius-sm)`,
"rounded-l-md" :
`border-bottom-left-radius: var(--radius-md);
border-top-left-radius: var(--radius-md)`,
"rounded-l-lg" :
`border-bottom-left-radius: var(--radius-lg);
border-top-left-radius: var(--radius-lg)`,
"rounded-l-xl" :
`border-bottom-left-radius: var(--radius-xl);  
border-top-left-radius: var(--radius-xl)`, 
"rounded-l-2xl" :
`border-bottom-left-radius: var(--radius-2xl);
border-top-left-radius: var(--radius-2xl)`,
"rounded-l-3xl" :
`border-bottom-left-radius: var(--radius-3xl);
border-top-left-radius: var(--radius-3xl)`,
"rounded-l-4xl" :
`border-bottom-left-radius: var(--radius-4xl); 
border-top-left-radius: var(--radius-4xl)`,
"rounded-l-full" :
`border-top-left-radius: calc(infinity * 1px); 
border-bottom-left-radius: calc(infinity * 1px)`,
    },
    "border-top-left-radius":{
      "rounded-tl-xs": "var(--radius-xs)",
      "rounded-tl-sm": "var(--radius-sm)",
      "rounded-tl-md": "var(--radius-md)",
      "rounded-tl-lg": "var(--radius-lg)",
      "rounded-tl-xl": "var(--radius-xl)",
      "rounded-tl-2xl": "var(--radius-2xl)",
      "rounded-tl-3xl": "var(--radius-3xl)",
      "rounded-tl-4xl": 'var(--radius-4xl)',
    },
    "border-top-right-radius":{
      "rounded-tr-xs": "var(--radius-xs)",
      "rounded-tr-sm": "var(--radius-sm)",
      "rounded-tr-md": "var(--radius-md)",
      "rounded-tr-lg": "var(--radius-lg)",
      "rounded-tr-xl": "var(--radius-xl)",
      "rounded-tr-2xl": "var(--radius-2xl)",
      "rounded-tr-3xl": "var(--radius-3xl)",
      "rounded-tr-4xl": 'var(--radius-4xl)',
    },
    "border-bottom-right-radius":{
      "rounded-br-xs": "var(--radius-xs)",
      "rounded-br-sm": "var(--radius-sm)",
      "rounded-br-md": "var(--radius-md)",
      "rounded-br-lg": "var(--radius-lg)",
      "rounded-br-xl": "var(--radius-xl)",
      "rounded-br-2xl": "var(--radius-2xl)",
      "rounded-br-3xl": "var(--radius-3xl)",
      "rounded-br-4xl": 'var(--radius-4xl)',
    },
    "border-bottom-left-radius":{
      "rounded-bl-xs": "var(--radius-xs)",
      "rounded-bl-sm": "var(--radius-sm)",
      "rounded-bl-md": "var(--radius-md)",
      "rounded-bl-lg": "var(--radius-lg)",
      "rounded-bl-xl": "var(--radius-xl)",
      "rounded-bl-2xl": "var(--radius-2xl)",
      "rounded-bl-3xl": "var(--radius-3xl)",
      "rounded-bl-4xl": 'var(--radius-4xl)',
    }
  },
  exampleData: [
    {
      example: {
        code: `<div class="rounded-sm p-4 size-32">rounded-sm</div>
<div class="rounded-md p-4 size-32">rounded-md</div>
<div class="rounded-lg p-4 size-32">rounded-lg</div>
<div class="rounded-xl p-4 size-32">rounded-xl</div>
<div class="rounded-2xl p-4 size-32">rounded-2xl</div>        `
      }
    },
    {
      example: {
        code: `<div class="rounded-t-2xl p-2 size-32">rounded-t-2xl</div>
<div class="rounded-r-2xl p-2 size-32">rounded-r-2xl</div>
<div class="rounded-b-2xl p-2 size-32"> rounded-b-2xl</div>
<div class="rounded-l-2xl p-2 size-32">rounded-l-2xl</div>       `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-sm</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-md</code> to apply different border radius sizes to an element:
      </p>
      <div class="flex justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap">
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-sm p-4 size-32">rounded-sm</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-md p-4 size-32">rounded-md</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-lg p-4 size-32">rounded-lg</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-xl p-4 size-32">rounded-xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-2xl p-4 size-32">rounded-2xl</div>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-t-md</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-r-lg</code>
        to only round one side of an element:
      </p>
      <div class="flex justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap">
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-t-2xl p-4">rounded-t-2xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-r-2xl p-4">rounded-r-2xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-b-2xl p-4"> rounded-b-2xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-l-2xl p-4">rounded-l-2xl</div>
      </div>
      `
    },
        {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-tr-md</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-tl-lg</code>
        utilities to only round one corner of an element:
      </p>
      <div class="flex justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap">
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-tl-2xl p-4">rounded-tl-2xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-tr-2xl p-4">rounded-tr-2xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-br-2xl p-4"> rounded-br-2xl</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-bl-2xl p-4">rounded-bl-2xl</div>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-full</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">rounded-none</code>
        utility to create pill buttons or remove an existing border radius from an element:
      </p>
      <div class="flex justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap">
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-full p-4">rounded-full</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-none p-4">rounded-none</div>
          <div class="bg-color-blue-500 text-color-white flex justify-center items-center rounded-[10px] p-4"> rounded-[10px]</div>      </div>
      `
    }
  ]
};

export default borderRadius;
<div className="rounded-sm bg-color-blue-500 rounded-[10px] rounded-2xl rounded-t-2xl rounded-r-2xl rounded-b-2xl rounded-l-2xl rounded-tl-2xl rounded-tr-2xl rounded-br-2xl rounded-bl-2xl"></div>